import { createContext } from 'react';
export var AuthContext = createContext(undefined);
AuthContext.displayName = 'AuthContext';
//# sourceMappingURL=AuthContext.js.map